import RsmDialog from './RsmDialog'

export default RsmDialog
